import Event from "./ResponsiveEvent.jsx/Event"
import useFormContext from "./ResponsiveEvent.jsx/useFormContext"
import ScheduleRequestor from "./ResponsiveEvent.jsx/ScheduleRequestor"
import Guests from "./ResponsiveEvent.jsx/Guests"
import SummaryRequestor from "./ResponsiveEvent.jsx/SummaryRequestor"
import History from "./ResponsiveEvent.jsx/History"

const FormInputs = () => {

    const { page } = useFormContext()

    const display = {
        0: <Event />,
        1: <ScheduleRequestor familyMode="false" />,
        2: <Guests />,
        3: <History familyMode="false" />,
        4: <SummaryRequestor familyMode="false" />
    }

    const content = (
        <>
            {display[page]}
        </>
    )


    return content
}
export default FormInputs